import React from "react";
import c1 from '../assets/Google_Cloud_Digital_Leader_Track.png'
import c2 from '../assets/A National level Hackathon  (1)-1.png'
import c3 from '../assets/Architecturing image.png'

const Certifications = () => {
  return (
    <section id='Certifications' className="flex flex-col text-center justify-center md:space-x-8 space-x-0 pb-14 pt-20 bg-[#522258] text-white">
        <h1 className="md:text-3xl text-xl font-extrabold mb-12">Certifications</h1>
    <div className="flex md:flex-row flex-col justify-around py-8">
      {/* Certificate 1 */}
      <div className="text-center flex flex-col items-center ">
        <img
          src={c1} // Replace with actual image path
          alt="Certificate 1"
          className="w-48 h-auto rounded-md"
        />
        <p className="md:mt-8 mt-4 md:text-lg text-sm font-semibold ">Google Cloud Digital Leader </p>
      </div>

      {/* Certificate 2 */}
      <div className="text-center flex flex-col text-sm items-center md:pt-0 pt-14">
        <img
          src={c2} // Replace with actual image path
          alt="Certificate 2"
          className="w-48 h-auto rounded-md"
        />
        <p className="md:mt-8 mt-4 font-semibold md:text-lg text-sm">National Level Hackathon </p>
      </div>

      {/* Certificate 3 */}
      <div className="text-center flex flex-col items-center pt-14 md:pt-0 ">
        <img
          src={c3} // Replace with actual image path
          alt="Certificate 3"
          className="w-48 h-auto rounded-md"
        />
        <p className="md:mt-8 mt-4 font-semibold md:text-lg text-sm">Architecting with Google Kubernetes Engine</p>
      </div>
      </div>
    </section>
  );
};

export default Certifications;
